var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.$store.getters['user/getUser'].role === 'patient')?_c('patientSettings'):_vm._e(),(this.$store.getters['user/getUser'].role === 'psychologist')?_c('psyhSettings'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }